/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod';

/**
 * @description 204 response
 */
export const optionsInvestorDeclaration204Schema = z.any();

/**
 * @description 505 response
 */
export const optionsInvestorDeclaration505Schema = z.any();

export const optionsInvestorDeclarationMutationResponseSchema = z.lazy(() => optionsInvestorDeclaration204Schema);
